export const API_CONFIG = {
  BASE_URL: 'https://westbengalexam.mystudyplace.online/backend/',

  ENDPOINTS: {

    APPINSTALLPUSH: 'AppInstallPush.php',
    APPITEMSUSEPUSH: 'AppItemsUsePush.php',


  }
};

